import { ImperativeDialogRef } from '@/components/shared/dialogs/useImperativeDialogRef';
import { useBackBlocker } from '@/hooks/use-back-blocker';
import {
  ForwardedRef,
  useCallback,
  useImperativeHandle,
  useState,
} from 'react';

export default function useImperativeDialog(
  modalRef: ForwardedRef<ImperativeDialogRef>
) {
  const [isOpen, setIsOpen] = useState(false);

  useBackBlocker({
    enabled: isOpen,
    onBack: () => setIsOpen(false),
  });

  const onOpenChange = useCallback((open: boolean) => {
    setIsOpen(open);
  }, []);

  useImperativeHandle(modalRef, () => ({
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
  }));

  return { isOpen, onOpenChange };
}
